/**
 * Colonnes de texte (bloc columns_text) : bouton « lire la suite » de la colonne droite.
 * Remplace le composant Vue ColumnsText.
 */
UNYC.register('columns-text', () => {
    UNYC.init('[data-columns-text]', 'columns-text', (section) => {
        const right = section.querySelector('.text-right');
        const left = section.querySelector('.text-left');
        const editor = right ? right.querySelector('.editor') : null;
        const toggle = right ? right.querySelector('a[class^="link-"]') : null;

        if (!editor || !toggle) return;

        toggle.addEventListener('click', (event) => {
            event.preventDefault();

            editor.classList.toggle('show');
            toggle.classList.toggle('show');
            if (left) left.classList.toggle('hide-ellips');

            editor.style.maxHeight = editor.style.maxHeight ? '' : `${editor.scrollHeight}px`;
        });
    });
});
